import React from 'react';
import { Box } from '@chakra-ui/react';

import { LogoProps, calculateWidthAndHeight } from '../logoUtils';

const baseWidth = 148;
const baseHeight = 124;

export default (boxProps: LogoProps) => {
  const { height, width } = calculateWidthAndHeight({
    baseHeight,
    baseWidth,
    w: 'w' in boxProps ? boxProps.w : undefined,
    h: 'h' in boxProps ? boxProps.h : undefined,
  });
  return (
    <Box {...boxProps} w={width} h={height}>
      <svg
        width="100%"
        height="100%"
        display="inline-block"
        viewBox="0 0 148 124"
        version="1.1"
      >
        <title>Times Higher Education Logo</title>
        <g
          id="THE-Logo-Wrapper"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="THE-Logo" transform="translate(0.000100, -0.000400)">
            <polygon
              id="Fill-35"
              fill="#E30528"
              points="35.315 123.9951 12.992 123.9951 12.992 16.8121 7.81597009e-14 16.8121 7.81597009e-14 9.99999997e-05 48.782 9.99999997e-05 48.782 16.8121 35.315 16.8121"
            ></polygon>
            <polygon
              id="Fill-36"
              fill="#B70F7F"
              points="74.1973 63.7564 74.1973 123.9954 53.2563 123.9954 53.1083 0.0004 74.1973 0.0004 74.1973 46.9334 79.7153 46.9334 79.7153 0.0004 100.6533 0.0004 100.6533 123.9954 79.7153 123.9954 79.7153 63.7564"
            ></polygon>
            <polygon
              id="Fill-37"
              fill="#1A60AB"
              points="147.4273 16.812 127.5573 16.812 127.5573 48.61 144.2193 48.61 144.2193 63.756 127.5573 63.756 127.5573 105.338 147.4273 105.338 147.4273 123.995 105.8533 123.995 105.8533 -5.68434189e-14 147.4273 -5.68434189e-14"
            ></polygon>
          </g>
        </g>
      </svg>
    </Box>
  );
};
